import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportVehicleComponent } from './importVehicle.component';
import { VehicleListComponent } from './vehicle-list.component';
import { VehicleDetailComponent } from './vehicleDetail.component';
import { ExpectedVehicleComponent } from './expectedVehicle.component';
import { CurrentVehicleComponent } from './currentVehicle.component';

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Vehicle Management'
        },
        children: [
            {
                path: '',
                component: VehicleListComponent,
                data: {
                    title: 'Vehicle List'
                }
            },
            {
                path: 'vehicleInfo',
                component: VehicleListComponent,
                data: {
                    title: 'Vehicle List'
                }
            },
            {
                path: 'vehicleDetail',
                component: VehicleDetailComponent,
                data: {
                    title: 'Vehicle Detail'
                }
            },
            {
                path: 'importVehicle',
                component: ImportVehicleComponent,
                data: {
                    title: 'Import Vehicle'
                }
            },
            {
                path: 'expectedVehicle',
                component: ExpectedVehicleComponent,
                data: {
                    title: 'Expected Vehicle'
                }
            },
            {
                path: 'currentVehicle',
                component: CurrentVehicleComponent,
                data: {
                    title: 'Current Vehicle'
                }
            }
        ]
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class VehicleRoutingModule { }
